import React from "react";
import PropTypes from "prop-types";
import { Col, Pagination, Row } from "react-bootstrap";
import ScreenSelectPagination from "./ScreenSelectPagination";

export default function DataTablePagination(props) {
  return (
    <Row>
      <Col xs="auto">
        <Pagination size="sm">
          {props.numberPerScreenOptions.map(i => (
            <Pagination.Item
              active={i.num === props.numberPerScreen}
              key={"setRowsShownTo" + i.display}
              onClick={() => {
                props.setNumberPerScreen(i.num);
              }}
            >
              {i.display}
            </Pagination.Item>
          ))}
        </Pagination>
      </Col>
      <Col />
      <Col xs="auto">
        <Pagination size="sm">
          {props.numberOfScreens > 2 ? (
            props.displayedScreen !== 0 ? (
              <Pagination.First onClick={() => props.setDisplayedScreen(0)} />
            ) : (
              <Pagination.First disabled />
            )
          ) : null}
          {props.numberOfScreens > 1 ? (
            props.displayedScreen !== 0 ? (
              <Pagination.Prev
                onClick={() =>
                  props.setDisplayedScreen(
                    props.displayedScreen === 0 ? 0 : props.displayedScreen - 1
                  )
                }
              />
            ) : (
              <Pagination.Prev disabled />
            )
          ) : null}
          <ScreenSelectPagination
            activeScreen={props.displayedScreen}
            numberOfScreens={props.numberOfScreens}
            setDisplayedScreen={props.setDisplayedScreen}
          />
          {props.numberOfScreens > 1 ? (
            props.displayedScreen !== props.numberOfScreens - 1 ? (
              <Pagination.Next
                onClick={() =>
                  props.setDisplayedScreen(
                    props.displayedScreen === props.numberOfScreens + 1
                      ? props.displayedScreen
                      : props.displayedScreen + 1
                  )
                }
              />
            ) : (
              <Pagination.Next disabled />
            )
          ) : null}
          {props.numberOfScreens > 2 ? (
            props.displayedScreen !== props.numberOfScreens - 1 ? (
              <Pagination.Last
                onClick={() => {
                  props.setDisplayedScreen(props.numberOfScreens - 1);
                }}
              />
            ) : (
              <Pagination.Last disabled />
            )
          ) : null}
        </Pagination>
      </Col>
    </Row>
  );
}

DataTablePagination.propTypes = {
  displayedScreen: PropTypes.number.isRequired,
  numberOfScreens: PropTypes.number.isRequired,
  numberPerScreen: PropTypes.number.isRequired,
  numberPerScreenOptions: PropTypes.array.isRequired,
  setDisplayedScreen: PropTypes.func.isRequired,
  setNumberPerScreen: PropTypes.func.isRequired
};
